// frontend/src/components/parent/ChildSelector.tsx

import { ChildSummary } from '../../types/parent.types';
import { IconUsers, IconPlus } from './ParentIcons';

function initials(fullName: string): string {
  return fullName
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase())
    .join('');
}

interface ChildSelectorProps {
  children: ChildSummary[];
  selectedId: string | null;
  onSelect: (id: string) => void;
  onAddChild?: () => void;
}

const AVATAR_GRADIENTS = [
  'linear-gradient(135deg, #00AEEF, #38C9F5)',
  'linear-gradient(135deg, #10C27A, #34D399)',
  'linear-gradient(135deg, #7C3AED, #A78BFA)',
  'linear-gradient(135deg, #FF7043, #F59E0B)',
];

export function ChildSelector({ children, selectedId, onSelect, onAddChild }: ChildSelectorProps) {
  return (
    <div className="pcd-child-selector">
      <div className="pcd-selector-label">
        <IconUsers size={16} />
        <span>Çocuk Seç</span>
      </div>
      <div className="pcd-selector-pills">
        {children.map((child, idx) => (
          <button
            key={child.id}
            type="button"
            className={`pcd-child-pill ${selectedId === child.id ? 'active' : ''}`}
            onClick={() => onSelect(child.id)}
          >
            <span
              className="pcd-pill-avatar"
              style={{ background: AVATAR_GRADIENTS[idx % AVATAR_GRADIENTS.length] }}
            >
              {initials(child.full_name)}
            </span>
            <span className="pcd-pill-name">{child.full_name.split(' ')[0]}</span>
            {child.current_streak_days > 0 && (
              <span className="pcd-pill-streak" title={`${child.current_streak_days} günlük seri`}>
                {child.current_streak_days}
              </span>
            )}
          </button>
        ))}
        {onAddChild && (
          <button type="button" className="pcd-add-child-btn" onClick={onAddChild} title="Başka çocuk bağla">
            <IconPlus size={16} />
          </button>
        )}
      </div>
    </div>
  );
}
